import { Box, Image } from "@chakra-ui/react";
import banner1 from "../../Assets/banner1.jpg";

export default function Banner1() {
  return (
    <>
      <Box maxW={{ base: "95%", md: "90%", lg: "90%" }} m="auto" mt="20px">
        <Image margin="auto" boxSize="100%" src={banner1} />
      </Box>
    </>
  );
}
